export const state = () => ({
  blogs: [],
  filters: null,
  currentBlog: null,
  totalResults: 0,
  currentPage: 1
})

export const mutations = {
  SET_BLOGS(state, blogs) {
    state.blogs = blogs.data || []
    state.totalResults = blogs.total || 0
    state.currentPage = blogs.current_page || 1
  },
  SET_FILTERS(state, filters) {
    state.filters = filters
  },
  SET_CURRENT_BLOG(state, blog) {
    state.currentBlog = blog
  }
}

export const actions = {
  async getBlogs({ commit }, data) {
    const filters = new URLSearchParams(data).toString()
    const res = await this.$axios.get('/blogs?' + filters)
    commit('SET_BLOGS', res.data)
    return res.data
  },
  async getBlog({ commit }, blog) {
    const res = await this.$axios.get('/blogs/' + blog)
    commit('SET_CURRENT_BLOG', res.data)
    return res.data
  },
  async getFilters({ commit }) {
    const res = await this.$axios.get('/blogs/filters')
    commit('SET_FILTERS', res.data)
    return res.data
  },
}
